import produce from 'immer';
import * as elementErrorsActionTypes from '../../constants/actionTypes/elementErrors';
import elementErrorsMethod from '../methods/elementErrors';

const elementErrors = (state = [], action) => produce(state, (draftState) => {
    switch (action.type) {
        case elementErrorsActionTypes.ADD_ERRONEOUS_ELEMENT:
            return elementErrorsMethod.addErroneousElement(draftState, action);

        case elementErrorsActionTypes.DELETE_ERRONEOUS_ELEMENT:
            return elementErrorsMethod.deleteErroneousElement(draftState, action);
        default:
            return state;
    }
});

export default elementErrors;
